var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 135,
    viewBox: "0 0 136 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 67.5C135.5 104.7 105.3 135 68 135C30.7 135 0.5 104.7 0.5 67.5C0.5 30.2 30.7 0 68 0C105.3 0 135.5 30.2 135.5 67.5Z",
    fill: "#DA0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113 67.5C113 77.2333 112.367 84.4333 111.1 89.1C110.1 93 107 96 103.2 97.1C98.4667 98.3667 86.7333 99 68 99C49.2667 99 37.5333 98.3667 32.8 97.1C29 96 25.9 93 24.9 89.1C23.6334 84.4333 23 77.2333 23 67.5C23 57.7 23.6334 50.4667 24.9 45.8C25.9 41.9 29 38.9 32.8 37.8C37.5333 36.6 49.2667 36 68 36C86.7333 36 98.4667 36.6 103.2 37.8C107 38.9 110.1 41.9 111.1 45.8C112.367 50.4667 113 57.7 113 67.5ZM82.4 67.5L59 54V81L82.4 67.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bb2387598b5621f3a2e92ab928da4fe0.svg";
export { ForwardRef as ReactComponent };